export const storage = {
    DP_CURBSIDE_CHECKIN_INFO: 'DP_CURBSIDE_CHECKIN_INFO',
    DP_CURBSIDE_PRODUCT_INFO: 'DP_CURBSIDE_PRODUCT_INFO',
};

export const nSSRReturnStatus = {
    Completed: 'Complete',
    InProgress: 'in Progress',
    Cancelled: 'Canceled',
};

export const nSSRDateStatus = {
    Completed: 'Completed',
    InProgress: 'Started',
    Cancelled: 'Canceled',
};
